
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.02 26.992A1.487 1.487 0 1116.5 25.5a1.486 1.486 0 01-1.48 1.492zm7.451-3.1a1.471 1.471 0 01-1.048-.436 1.492 1.492 0 010-2.1 1.479 1.479 0 012.1 0 1.492 1.492 0 010 2.1 1.471 1.471 0 01-1.052.444zm-14.9 0a1.469 1.469 0 01-1.051-.432 1.492 1.492 0 010-2.1 1.479 1.479 0 012.1 0 1.491 1.491 0 010 2.1 1.469 1.469 0 01-1.052.44zM4.482 16.42a1.487 1.487 0 111.482-1.487 1.486 1.486 0 01-1.482 1.487zm21.069-.008A1.452 1.452 0 0124.1 14.96a9.041 9.041 0 00-9.026-9.055 1.453 1.453 0 010-2.905A11.94 11.94 0 0127 14.96a1.452 1.452 0 01-1.448 1.453zm-5.291-.02h-5.792a.86.86 0 01-.857-.86v-4.584a.858.858 0 111.715 0v3.724h4.934a.86.86 0 010 1.721zM7.568 8.946A1.471 1.471 0 016.52 8.51a1.492 1.492 0 010-2.1 1.479 1.479 0 012.1 0 1.492 1.492 0 010 2.1 1.471 1.471 0 01-1.052.436z","fill":"#222"}})])
          )
        }
      }
    